import { Link } from 'react-router-dom';
import { BookOpen, Users, ArrowRight } from 'lucide-react';
import { Reveal } from '../Reveal';
import { ELI_ELY_SLUG } from '../../lib/library';

export default function EliElyFeature() {
  return (
    <Reveal>
      <div className="relative rounded-3xl border border-fuchsia-400/30 overflow-hidden" data-testid="eli-ely-feature">
        <img src="/u99/eli-ely-character-map.png" alt="Eli & Ely character map" className="absolute inset-0 w-full h-full object-cover opacity-30" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#02040a] via-[#02040a]/85 to-[#02040a]/30" />
        <div className="relative p-7 lg:p-10">
          <span className="inline-flex items-center gap-2 font-mono-precision text-[10px] uppercase tracking-[0.3em] text-fuchsia-300"><BookOpen size={13} /> The novel · Free to read</span>
          <h3 className="mt-5 font-celestial text-3xl sm:text-4xl text-slate-100 leading-tight">ELI &amp; ELY: <span className="text-fuchsia-200">THE SPLIT PART ONE</span></h3>
          <p className="mt-2 font-celestial text-lg italic text-slate-400">by Kyle Hinton</p>
          <div className="mt-7 flex flex-wrap gap-3">
            <Link to={`/u99/documents/${ELI_ELY_SLUG}`} className="inline-flex items-center gap-2 font-mono-precision text-[10px] uppercase tracking-[0.25em] px-5 py-3 rounded-full border border-fuchsia-400/50 text-fuchsia-200 hover:bg-fuchsia-400/10 transition-colors" data-testid="eli-ely-read-btn">Open the novel <ArrowRight size={12} /></Link>
            <Link to="/u99/world/eli-and-ely" className="inline-flex items-center gap-2 font-mono-precision text-[10px] uppercase tracking-[0.25em] px-5 py-3 rounded-full border border-white/15 text-slate-300 hover:text-slate-100 hover:border-white/40 transition-colors" data-testid="eli-ely-world-btn"><Users size={12} /> The characters</Link>
          </div>
        </div>
      </div>
    </Reveal>
  );
}
